import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import images from "../../../assets/images/constantImages";
import toast from "react-hot-toast";
import apiService, { handleError } from "../ApiCommon/ApiService";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const ForgetPassword = () => {
  const { role } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  // Validation Schema
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const apiUrl =
    role === "staff"
      ? "/staff_users/forgot_password"
      : role === "vendor" ? "/vendors/forgot_password"
        : role === "canteenUser" ? "/canteen_users/forgot_password" : "/vendors/forgot_password"

  const handleSubmit = async (values, { setSubmitting }) => {
    setIsSubmitting(true)
    try {
      const response = await axios.post(`https://headquater.pixoatic.com/api/v1${apiUrl}`, { email: values.email });
      console.log("responce1", response);
      console.log("responce1", response.data?.data?.id);
        const userId = response?.data?.data?.id;
        if (userId) {
          console.log(userId);
          
          localStorage.setItem("userId", userId.toString());
          localStorage.setItem("role", role);
          toast.success("OTP has been sent to your email", {
            duration: 2000,
          });
          navigate("/otpConfirmation");
        }
    } catch (errors) {
      toast.error(errors?.response?.data?.errors?.[0]?.otp)

    } finally {
      setSubmitting(false);
    }
  };
  return (
    <>
      <div className="w-full bg-green flex justify-center items-center relative">
        <div className="w-full ">
          <img
            src={images.loginimage}
            alt="loginimage"
            className="w-full h-screen backdrop-blur-[8px] mix-blend-multiply"
          />
          <div className="absolute top-0 z-10 w-full">
            <img
              src={images.loginclipimage}
              alt=""
              className="w-full h-screen opacity-[8%]"
            />
          </div>
          <div className="absolute sm:right-10 lg:top-8 top-3 right-2">
            <img src={images.logo} alt="logo" className="w-[180px] h-[75px]" />
          </div>
        </div>
        <div className="bg-white rounded-lg w-[320px] xs:w-[430px] shadow-lg p-8 absolute z-30">
          <div className="w-full">
            <h1 className="text-G800 font-bold text-[25px] xs:text-[32px] mb-4">
              Forget Password
            </h1>
            <p className="text-G200 font-normal text-sm xs:text-[16px] leading-[24px]  mb-6">
              Enter your email to receive a password reset link.
            </p>
            <Formik
              initialValues={{ email: "" }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form>
                  {/* Email Field */}
                  <div className="mb-4">
                    <label
                      htmlFor="email"
                      className="text-[16px] text-G200 mb-2"
                    >
                      Email Address
                    </label>
                    <Field
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter your email"
                      className="w-full border border-G30 rounded-lg text-G80 p-3 text-sm z-30 outline-none"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-sm text-red "
                    />
                  </div>

                  {/* Submit Button */}
                  <div className="mt-6">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className={`w-full py-2 px-4 bg-green text-white rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                    >
                      {isSubmitting ? "Sending..." : "Get OTP"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
            {/* Back to Login */}
            <div className="mt-4 text-center ">
              <a
                href="/"
                className="text-blue-600 text-sm hover:underline focus:outline-none"
              >
                Back to Login
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
